import { getFilenameFromContentDisposition } from '@/utils';
import http, { getBlobConfig, getUniversityUrl } from './http';

export async function downloadFile(fileId: string) {
  const baseURL = getUniversityUrl();
  const url = `/rest/file/download/${fileId}`;

  try {
    const response = await http.get(url, {
      ...getBlobConfig(baseURL),
      responseType: 'blob',
    });

    const disposition = response.headers['content-disposition'];
    const filename = getFilenameFromContentDisposition(disposition);

    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');

    link.href = blobUrl;
    link.setAttribute('download', filename);

    document.body.appendChild(link);
    link.click();

    link.remove();

    window.URL.revokeObjectURL(blobUrl);

  }
  catch (err) {
    console.error('Download failed', err);
  }
}
